import { Card, Divider, Flex, Row, Select, Tabs } from 'antd'; // นำเข้า Select จาก Ant Design
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux"; // นำเข้า hook useWelfare ที่สร้างไว้
import CreateTemplateFromEmail from './createTemplateFormEmail';
import CreateTemplateFormMobile from "./createTemplateFormMobile";
import { Info } from 'components/elements';

const { Option } = Select; // นำเข้า Option จาก Ant Design

const CreagteTemplateFrom = ({ incomeOptions, getTemplateData, onSubmit }) => { // รับ incomeOptions เข้ามาจาก props
    // const [showCCInput, setShowCCInput] = useState(true);
    const { t, i18n } = useTranslation();
    const templateShow = useSelector((state) => state.template.templateData);
    const [options, setOptions] = useState([]);

    const onChangeTab = (key) => {
        console.log(key);
    };
    const onChange = (id) => {
        getTemplateData(id);
    }

    useEffect(() => {
        setOptions(
            incomeOptions.map(option => ({
                ...option,
                name: i18n.language === 'en' ? option.nameEn : option.name,
            }))
        );
    }, [i18n.language, incomeOptions]);

    return (
        <Card style={{ width: '100%', padding: "10px" }}>
            <Row justify="space-between">
                <b className="Topic">{t('creatTamplete.header')}</b>
            </Row>
            <Divider />
            <Flex vertical style={{ rowGap: "12px" }}>
                <Info
                    label={t("creatTamplete.label.event_email")}
                    value={<Select style={{ width: 250 }} onChange={onChange} placeholder={t("creatTamplete.placeholder.event_email")}>
                        {options.map(option => (
                            <Option key={option.id} value={option.id}>
                                {option?.name}
                            </Option>
                        ))}
                    </Select>} />
                <CreateTemplateFromEmail onSubmit={onSubmit} />
            </Flex>
        </Card>
    );
};

export default CreagteTemplateFrom;
